import * as React from 'react';

import { DropdownMenuItem } from 'layouts/AppPageTemplate/utils/menus';
import { Region } from 'services/clients/regions';
import { Item } from './Item';

interface Props {
  category: DropdownMenuItem;
  region: Region;
}

export const CategoryGroup: React.FC<Props> = (props) => {
  const { region, category } = props;

  return (
    <div className="">
      <h2 className="font-bold border-b border-gray-100 pb-2">{category.title}</h2>
      <ul className="">
        {category.children.map((item) => (
          <Item item={item} region={region} key={item.page.path} />
        ))}
      </ul>
    </div>
  );
};
CategoryGroup.displayName = 'Landing.Menu.CategoryGroup';
